import {Component, EventEmitter, Input, Output} from "@angular/core";
import {Employee} from "../../../../../../../../server/src/base/entities/employee/Employee";

@Component({
    selector: 'admin-employee',
    templateUrl: './employee.html',
    styleUrls: ['./employee.scss']
})
export class AdminEmployeeComponent {

    @Input() employee:Employee;
    @Output() removing:EventEmitter<Employee> = new EventEmitter<Employee>();

    remove(){
        this.removing.emit(this.employee);
    }

}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/admin/employees/employee/employee.ts